export default __webpack_public_path__ + "static/media/11.4.717722e6.jpg";